// extracted by mini-css-extract-plugin
export default {"badge":"PostNotificationBadge_badge__Waaun","pulse":"PostNotificationBadge_pulse__pKrnW"};